<template>
    <v-container fluid class="pa-6">
        <DatatableV2 :displayTitle="false" :flat="false" :url="apiUrl" @saveFormDialogComponent="saveForm"/>
    </v-container>
</template>
<script>
import DatatableV2 from '@/components/DatatableV2'
export default {
    name:"EntityList",
    components: {
        DatatableV2
    },
    data() {
        return {
            apiUrl:"/entity/list",
        }
    },
    methods: {
        saveForm(response) {
            this.$store.dispatch('auth/GET_CURRENT_USER', {}, { root: true });
        }
    }
}
</script>
<style lang="scss">

</style>
